import { createReducer, on } from '@ngrx/store';
import { PendingLink, PendingLinksListMeta } from '../models/pending-link.model';
import * as PendingLinksActions from './pending-links.actions';

export interface PendingLinksQueryState {
  search?: string;
  status?: string;
  sourceSurface?: string;
  sort?: string;
  sortDirection?: string;
}

export interface PendingLinksState {
  pendingLinks: PendingLink[];
  meta: PendingLinksListMeta | null;
  isLoading: boolean;
  isDeciding: boolean;
  isExporting: boolean;
  error: string | null;
  exportMessage: string | null;
  lastQuery: PendingLinksQueryState;
}

const initialState: PendingLinksState = {
  pendingLinks: [],
  meta: null,
  isLoading: false,
  isDeciding: false,
  isExporting: false,
  error: null,
  exportMessage: null,
  lastQuery: {},
};

export const pendingLinksReducer = createReducer(
  initialState,

  on(PendingLinksActions.loadPendingLinks, (state, action) => ({
    ...state,
    isLoading: true,
    error: null,
    lastQuery: {
      search: action.search,
      status: action.status,
      sourceSurface: action.sourceSurface,
      sort: action.sort,
      sortDirection: action.sortDirection,
    },
  })),
  on(PendingLinksActions.loadPendingLinksSuccess, (state, { pendingLinks, meta }) => ({
    ...state,
    pendingLinks,
    meta,
    isLoading: false,
  })),
  on(PendingLinksActions.loadPendingLinksFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(PendingLinksActions.decidePendingLink, (state) => ({
    ...state,
    isDeciding: true,
    error: null,
  })),
  on(PendingLinksActions.decidePendingLinkSuccess, (state) => ({
    ...state,
    isDeciding: false,
  })),
  on(PendingLinksActions.decidePendingLinkFailure, (state, { error }) => ({
    ...state,
    isDeciding: false,
    error,
  })),

  on(PendingLinksActions.bulkDecidePendingLinks, (state) => ({
    ...state,
    isDeciding: true,
    error: null,
  })),
  on(PendingLinksActions.bulkDecidePendingLinksSuccess, (state) => ({
    ...state,
    isDeciding: false,
  })),
  on(PendingLinksActions.bulkDecidePendingLinksFailure, (state, { error }) => ({
    ...state,
    isDeciding: false,
    error,
  })),

  on(PendingLinksActions.exportPendingLinks, (state) => ({
    ...state,
    isExporting: true,
    exportMessage: null,
    error: null,
  })),
  on(PendingLinksActions.exportPendingLinksSuccess, (state, { message }) => ({
    ...state,
    isExporting: false,
    exportMessage: message ?? 'Your export request is being processed.',
  })),
  on(PendingLinksActions.exportPendingLinksFailure, (state, { error }) => ({
    ...state,
    isExporting: false,
    error,
  })),

  on(PendingLinksActions.resetPendingLinksState, () => initialState)
);
